import React, { FC } from 'react';
import { Page404Layout } from '../components/admin';

export const Page404: FC = () => {
  return <Page404Layout>Page 404</Page404Layout>;
};
